import {
  Children,
  cloneElement,
  createContext,
  FC,
  isValidElement,
  useContext,
  useMemo,
} from "react";
import { css } from "src/styles/theme";
import { nanoid } from "nanoid";

const FormFieldContext = createContext<{ id: string } | null>(null);

const Field: FC = ({ children }) => {
  const id = useMemo(() => `id-${nanoid()}`, []);
  const contextValue = useMemo(() => ({ id }), [id]);

  return (
    <FormFieldContext.Provider value={contextValue}>
      <div className={$field()}>{children}</div>
    </FormFieldContext.Provider>
  );
};

const Label: FC = ({ children }) => {
  const ctx = useContext(FormFieldContext);
  return (
    <label htmlFor={ctx?.id} className={$label()}>
      {children}:
    </label>
  );
};

const Input: FC = ({ children }) => {
  const id = useContext(FormFieldContext)?.id;

  const child = Children.only(children);
  const childWithInput = isValidElement(child) && cloneElement(child, { id });

  return <>{childWithInput}</>;
};

export const FormField = { Field, Label, Input };

const $field = css({
  height: "100%",
  display: "flex",
  alignItems: "stretch",
  borderRadius: "$2",
  backgroundColor: "$neutralBgSubtle",
  transition: "all $duration1 ease",

  "&:focus-within": {
    backgroundColor: "$neutralBg",
  },
});

const $label = css({
  display: "flex",
  alignItems: "center",
  margin: 0,
  padding: "0 $2",
  color: "$neutral9",
  fontSize: "$sm",
  userSelect: "none",
  whiteSpace: "nowrap",
});
